import script from "./InputMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputMessage.vue?vue&type=script&setup=true&lang=ts"

import "./InputMessage.vue?vue&type=style&index=0&id=590352f7&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-590352f7"]])

export default __exports__